var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/smile/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 201 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 204 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0159 13.0839C7.52198 12.8628 8.1115 13.0938 8.33262 13.5999C8.95078 15.0147 10.3615 16.0003 12.0002 16.0003C13.6389 16.0003 15.0497 15.0147 15.6678 13.5999C15.8889 13.0938 16.4785 12.8628 16.9846 13.0839C17.4906 13.305 17.7217 13.8945 17.5005 14.4006C16.5756 16.5176 14.4622 18.0003 12.0002 18.0003C9.53829 18.0003 7.42487 16.5176 6.49992 14.4006C6.2788 13.8945 6.50981 13.305 7.0159 13.0839Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 202",
    d: "M9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9Z",
    fill: "#6F767E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 203",
    d: "M17 9C17 9.55228 16.5523 10 16 10C15.4477 10 15 9.55228 15 9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9Z",
    fill: "#6F767E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileLight);
export default __webpack_public_path__ + "static/media/smile-light.a4d36cf059048eb012064e11a8b04689.svg";
export { ForwardRef as ReactComponent };